module.exports = __webpack_public_path__ + "static/Fridge-210b17c7f71ff22624509c8369842a82.png";